(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ub-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.ub-size-chart-accordion').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      let columns;
      let rows;

      try {
        columns = JSON.parse(root.dataset.columns || '[]');
        rows = JSON.parse(root.dataset.rows || '[]');
      } catch (error) {
        return;
      }

      const table = root.querySelector('.ub-size-chart-accordion__table');
      const note = root.querySelector('[data-ub-note]');
      const unitButtons = [...root.querySelectorAll('[data-ub-unit]')];

      const formatValue = (value, unit) => {
        if (value === '' || value === null || value === undefined) return '—';
        if (unit === 'in') return value;

        const number = Number.parseFloat(String(value).replace(',', '.'));
        if (!Number.isFinite(number)) return value;

        return (Math.round(number * 2.54 * 10) / 10).toFixed(1).replace(/\.0$/, '');
      };

      const renderTable = (unit) => {
        table.replaceChildren();

        const head = document.createElement('thead');
        const headRow = document.createElement('tr');

        columns.forEach((column) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = column;
          headRow.append(cell);
        });

        head.append(headRow);
        table.append(head);

        const body = document.createElement('tbody');

        rows.forEach((row) => {
          const tableRow = document.createElement('tr');
          const label = document.createElement('th');

          label.scope = 'row';
          label.textContent = row.label;
          tableRow.append(label);

          row.values.forEach((value) => {
            const cell = document.createElement('td');
            cell.textContent = formatValue(value, unit);
            tableRow.append(cell);
          });

          body.append(tableRow);
        });

        table.append(body);

        note.innerHTML = unit === 'cm'
          ? 'Measurements are in centimeters <span aria-hidden="true">|</span> A variance of +/- 1.3 cm is within tolerance'
          : 'Measurements are in inches <span aria-hidden="true">|</span> A variance of +/- 0.5&quot; is within tolerance';
      };

      const setUnit = (unit) => {
        unitButtons.forEach((button) => {
          const active = button.dataset.ubUnit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        renderTable(unit);
      };

      unitButtons.forEach((button) => {
        button.addEventListener('click', () => setUnit(button.dataset.ubUnit));
      });

      setUnit('in');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
